module.exports = __webpack_public_path__ + "img/ehs.f167e17c.jpg";